import { Stack } from 'expo-router';
import React from 'react';

function BuyNowPayLaterLayout() {
  return <Stack />;
}

export default BuyNowPayLaterLayout;
